module.exports = __webpack_public_path__ + "alimentation.png?15154286953ea83a86b60634f4c0be3f";